import React from 'react';
import tinycolor from "tinycolor2";


export default class FixedSpeaker extends React.Component {
  
  colors = {
    text: window.theme.palette.background.txt || '#333333',
    background: window.theme.palette.background.paper,
    primary: window.theme.palette.primary.main,
    secondary: window.theme.palette.primary.main,
  };

  constructor() {
    super();
    this.primaryDarken = tinycolor(this.colors.primary).darken(5).toString();
  }
//style={{ background: `linear-gradient(to bottom, ${this.primaryDarken}, ${this.colors.primary} 50%)` }}
  render() {
    return (
      <div className="fixed-speaker empty" style={{ color: '#fff', backgroundColor: this.colors.secondary }}>
        <div className="fixed-speaker__img">
          <img className="img-fluid" src="/public/trans.png" />
        </div>
        <div className="fixed-speaker__content" style={{ background: `linear-gradient(to bottom, ${this.primaryDarken}, ${this.colors.primary} 50%)` }}>
          <h3 className="fixed-speaker__name"></h3>
          <p className="fixed-speaker__job"></p>
  
          <p className="fixed-speaker__group">
            <span className="fixed-speaker__grouptitle"></span>
            <span className="fixed-speaker__groupvalue"></span>
          </p>
  
          <p className="fixed-speaker__group">
            <span className="fixed-speaker__grouptitle"></span>
            <span className="fixed-speaker__groupvalue"></span>
          </p>
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/Player/FixedSpeaker.js